import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import SideBar from "../SideBar/SideBar";

const useStyles = makeStyles((theme) => ({
  legalFooter: {
    fontSize: "9px",
    color: "#999999",
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    justifyContent: "flex-end",
    fontFamily: "'Be Vietnam Pro', sans-serif",
    padding: theme.spacing(0, 3),
    paddingBottom: theme.spacing(2),

    // Make it stack vertically on small screens
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      gap: "4px",
      fontSize: "10px", // Slightly larger for readability on small screens
    },
  },
}));


export default function Layout({ children }) {
  const classes = useStyles();

  return (
    <div style={{ minHeight: "100vh", width: "100%", display: "flex" , flexDirection: "column", justifyContent: "space-between"}}>
      <SideBar> {children}</SideBar>
      <div className={classes.legalFooter}>
        <span>© 2025 IRIS Portal. All rights reserved</span>
        <span>Privacy Policy</span>
        <span>Terms of Service</span>
      </div>
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};
